import { UserData } from './user-data';

export interface AccountUsersData {
    paginationToken: string;
    users: UserData[];
}
